module.exports = __webpack_public_path__ + "static/media/LDV-Logo-1.b3e7f3d3.png";